import axios from 'index/axios'
// 创建表单
export const createFormRequest = (data) => {
  const payload = { ...data }
  if (payload.title && !payload.name) payload.name = payload.title
  if (payload.desc && !payload.description) payload.description = payload.desc
  return axios.post('/user/form/create', payload)
}
// 修改表单
export const updateFormRequest = (data) => axios.post('/user/form/update', data)
// 获取项目详情
export const getProjectRequest = (formKey) => axios.get(`/user/form/${formKey}`)
//恢复表单
export const restoreRecycleFormRequest = (data) => axios.post('/user/form/recycle/restore', data)
// 从回收站删除表单
export const deleteRecycleFormRequest = (data) => axios.post('/user/form/recycle/delete', data)
// 查询回收站表单
export const listRecycleFormRequest = (data) => axios.post('/user/form/recycle/page', data)
// 逻辑删除表单
export const logicDeleteFormRequest = (data) => axios.post('/user/form/logic/delete', data)
// 删除表单
export const deleteFormRequest = (data) => axios.post('/user/form/delete', data)

// 停止收集表单
export const stopFormRequest = (data) => axios.post('/user/form/stop', data)

// 复制问卷
export const copyForm = (formKey) => axios.post('/user/form/copy', { formKey })

// 查询表单分页
export const pageFormRequest = (params) => axios.get('/user/form/page', params)

// 查询表单项内容
export const listProjectItemRequest = (params) => axios.get('/user/form/item/list', params)

// 查询表单项内容
export const listFormFieldsRequest = (formKey) => axios.get(`/user/form/fields/${formKey}`)

// 查询固定表单项内容
export const listFixedFormFieldsRequest = (formKey) => axios.get(`/user/form/fixed/fields/${formKey}`)

// 查询表单逻辑列表（后端实际路由：/user/form/logic/{formKey}）
export const getFormLogicRequest = (formKey) => axios.get(`/user/form/logic/${formKey}`)

// 保存表单逻辑
export const saveFormLogicRequest = (data) => axios.post('/user/form/logic/save', data)

// 查询主题列表
export const listThemeRequest = (params) => axios.get('/form/theme/list', params)

// 保存表单选中主题
export const saveUserThemeRequest = (data) => axios.post('/user/form/theme/save', data)

// 查询表单主题
export const getUserThemeRequest = (projectKey) => axios.get(`/user/form/theme/${projectKey}`)

// ===================== 考试阅卷相关 =====================

// 获取表单题目列表
export const getFormItems = (formKey) => axios.get(`/user/form/items/${formKey}`)

// 分页查询答题记录
export const getAnswerPage = (data) => axios.post('/user/form/answer/page', data)

// 获取答题详情（含审核信息）
export const getReviewDetail = (answerKey) => axios.get(`/user/form/answer/review/${answerKey}`)

// 提交审核结果（一审/二审/三审）
export const submitReview = (data) => axios.post('/user/form/answer/review', data)

// 删除答题记录
export const deleteAnswer = (answerKey) => axios.post(`/user/form/answer/delete/${answerKey}`)

// 获取单条答题记录详情（含答题内容）
export const getAnswerDetail = (answerKey) => axios.get(`/user/form/answer/${answerKey}`)

// 获取同一经销商其他阶段的答卷数据（审核合并展示用）
export const getCrossPhaseData = (dealerCode, currentFormKey) =>
  axios.post('/user/form/cross-phase-data', { dealerCode, currentFormKey })

// ===================== 作废 / 修改审核 / 恢复（42 号方案 D 部分）=====================

// 作废某级审核（级联清除 ≥ N 级）
export const voidReviewLevel = (data) => axios.post('/user/form/answer/review/void-level', data)

// 修改审核（研究员 / 管理员 事后修正，无时间限制）
export const modifyReview = (data) => axios.post('/user/form/answer/review/modify', data)

// 恢复到历史版本
export const restoreReview = (data) => axios.post('/user/form/answer/review/restore', data)

// 查询答卷审核历史（时间线）
export const getReviewHistory = (answerKey) => axios.get(`/user/form/answer/review/history/${answerKey}`)

// 查询单个历史版本快照
export const getReviewHistoryVersion = (answerKey, level, version) =>
  axios.get(`/user/form/answer/review/history/${answerKey}/${level}/${version}`)
